export const TWO_SLIDE_SHOW = 2;
export const THREE_SLIDE_SHOW = 3;
export const SUPPLEMENT_TYPE = 'supplementfactspanel';
export const NUTRITION_TYPE = 'nutritionfactspanel';
export const DRUG_FACTS_TYPE = 'drugfactspanel';
export const PET_NUTRITION_TYPE = 'petnutritionfactspanel';
export const AMINO_ACID_TYPE = 'aminoacidfactspanel';
